import api from '@pray/shared/utils/api';

export async function bulkUpdateLeadCampaigns({ campaignIds, updates }) {
  if (!campaignIds?.length) throw Error('Campaign IDs are required');
  if (!updates?.length) throw Error('Updates are required');

  const url = '/web/studio/lead-campaigns/bulk';
  const response = await api.executePutRequest(url, {
    campaign_ids: campaignIds,
    updates,
  });

  return response.data;
}
